import { HarvestTrackingStatus } from "~/types"
import Api from "~/utils/Api"
import { useMutation, useQuery } from "@tanstack/react-query"

export const useHarvestTrackingStatus = () =>
  useQuery({
    queryKey: ["harvest/tracking_status"],
    queryFn: () =>
      Api.get(`harvest/tracking_status`).then(
        (response) => response.data,
      ) as Promise<HarvestTrackingStatus>,
    refetchInterval: 60000,
    refetchOnWindowFocus: true,
  })

export const useUpdateHarvestEntryIsRunning = () =>
  useMutation({
    mutationFn: ({
      entryId,
      isRunning,
    }: {
      entryId: number
      isRunning: boolean
    }) =>
      Api.post(`harvest/entries/${entryId}/status`, { is_running: isRunning }),
  })
